
import React from "react";
import {Form,Button,Card,Container,Row,Col} from "react-bootstrap";
 import { useRegistroAsistencia } from '../hooks/useRegistroAsistencia';
 import Select from 'react-select';
 import DataTable from "react-data-table-component";

import { useContext,useState ,useEffect} from "react";
import { AuthContext } from "auth";
import {MensajeAlerta} from '../components/Messages/MensajeAlerta';
import {excelExport} from "../utils/excelExport";

// Generar lista de meses
const months = [
  { value: 1, label: "Enero" },
  { value: 2, label: "Febrero" },
  { value: 3, label: "Marzo" },
  { value: 4, label: "Abril" },
  { value: 5, label: "Mayo" },
  { value: 6, label: "Junio" },
  { value: 7, label: "Julio" },
  { value: 8, label: "Agosto" },
  { value: 9, label: "Septiembre" },
  { value: 10, label: "Octubre" },
  { value: 11, label: "Noviembre" },
  { value: 12, label: "Diciembre" },
];
const generateYears = () => {
  const startYear=2024;
  const today=new Date();
  const years = [];
  for (let year = startYear; year <= today.getFullYear(); year++) {
    years.push({value:year,label:year});
  }
  //console.log(years)
  return years;
};
function RegistroAsistencia() {
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth()+1);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  
  const years = generateYears(); 
  const [personaSeleccionada, setPersonaSeleccionada] = useState(null);


  const handleMonthChange = (e) => {
    console.log('handleMonthChange')
    setSelectedMonth(e.value);
  };
  const handleYearChange = (e) => {
    console.log('handleYearChange')
    setSelectedYear(e.value);
  };
  const handleActividadChange=async(e) =>{
    console.log('handleActividadChange')
    setActividadActual(e.value);
    
  }
  const handleSaveChanges=async(e) =>{
    console.log('handleSaveChanges')
    updateAsistenciaMesAno(asistenciaMesAno);
  };
    
    var {user}= useContext(AuthContext)
    let usuario=user.Usuario;
    
    const [columns, setColumns] = useState([]);
    const [loading, setLoading] = useState(true);
    const { getActividadesSelector,actividadesSelector,getAsistenciaMesAno,asistenciaMesAno,columnasAsistenciaMes,updateAsistenciaMesAno,setAsistenciaMesAno,respuestaActualizarAsistencia,actividadActual,setActividadActual} = useRegistroAsistencia();

    useEffect(() => {
      
      const loadTableData = async () => {
        setLoading(true);
        await getActividadesSelector();
        setLoading(false);
        return;
      };
  
      loadTableData();
    
    }, []);
    useEffect(() => {
      
      const loadTableData = async () => {
        setLoading(true);
        //await getActividadesSelector();
        const asistencia={
          Ano:selectedYear,
          Mes:selectedMonth,
          ActividadId:actividadActual
        }
        await getAsistenciaMesAno(asistencia);
        setLoading(false);
        return;
      };
  
      loadTableData();
    
    }, [actividadActual,selectedMonth,selectedYear]);
      
  const handleCheckboxChange = (consultanteId, fecha) => {
    setAsistenciaMesAno(prevState =>
      prevState.map(consultante => {
        if (consultante.ConsultanteId === consultanteId) {
          return {
            ...consultante,
            [fecha]: {
              ...consultante[fecha],
              Asistencia: {
                ...consultante[fecha].Asistencia,
                Presente: consultante[fecha].Asistencia?.Presente === 1 ? 0 : 1
              }
            }
          };
        }
        return consultante;
      })
    );
  };
  
    useEffect(() => {
      
      const loadTableData = async () => {
        setLoading(true);
        console.log('columnasAsistenciaMes')
        console.log(JSON.stringify(columnasAsistenciaMes));

        const dynamicColumns = [
          {
            name: "Nombre",
            selector: (row) => row.NombreCompleto,
            sortable: true,
            style: (row) => ({
              cursor: 'pointer',
            }),
            
          },
          ...columnasAsistenciaMes.map((date) => ({
            name: date.FechaDia,
          
            cell: row => (
             
                 <input
                type="checkbox"
                checked={!!row[date.Fecha]?.Asistencia?.Presente}
                onChange={() => handleCheckboxChange(row.ConsultanteId, date.Fecha)}
                disabled={row.NombreCompleto !== personaSeleccionada}
              />
           
            ),
            ignoreRowClick: true, 
            allowOverflow: true,
            button: true
          })),
        ];
        setColumns(dynamicColumns);
        setLoading(false);
      };
  
      loadTableData();
    }, [columnasAsistenciaMes,personaSeleccionada]);
    
     return (
      <>
     
        <Container fluid>
          
        <Row>
            <Col md="12">
              <Card className="strpied-tabled-with-hover">
                <Card.Header>
                  <Card.Title as="h4">Registro de Asistencia</Card.Title>
                  <p className="card-category">
                    En esta sección se puede registrar la asistencia mensual de cada actividad
                  </p>
                </Card.Header>
                <Card.Body className="table-full-width table-responsive px-0">
                <div className="pull-right ml-3">
                <Form>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label>Año</label>
                        <Select
                          placeholder='Selecciona una opción' 
                          name='Agno'
                          options={years}
                          className="basic-single"
                          classNamePrefix="select"
                          value={ years.filter(i=>{ 
                                  return i.value==selectedYear;})
                          }
                          onChange={
                              (e,prop) => { handleYearChange(e); }
                          }
                          
                          />
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      <Form.Group>
                        <label>Mes</label>
                        <Select
                          placeholder='Selecciona una opción' 
                          name='Mes'
                          options={months}
                          className="basic-single"
                          classNamePrefix="select"
                          value={ months.filter(i=>{ 
                                  return i.value==selectedMonth;
                              })
                          }
                          onChange={
                              (e,prop) => { handleMonthChange(e); }
                          }
                          
                          />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label>Actividad</label>
                        <Select
                          placeholder='Selecciona una opción' 
                          name='Actividades'
                          options={actividadesSelector}
                          className="basic-single"
                          classNamePrefix="select"
                          value={ actividadesSelector.filter(i=>{ 
                            return i.value==actividadActual;
                        })
                          }
                          onChange={
                              (e,prop) => { handleActividadChange(e); }
                          }
                          
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: base => ({
                              ...base,
                              zIndex: 9999
                            }),
                          }}
                        
                          />
                        
                      </Form.Group>
                    </Col>
                  </Row>
                  {personaSeleccionada && (
  <div style={{ position: 'sticky', top: 0, background: '#fafafa', padding: '8px', fontWeight: 'bold', borderBottom: '1px solid #ccc' }}>
    Editando asistencia de: {personaSeleccionada}
  </div>
)}
 {!personaSeleccionada && (
  <div style={{ position: 'sticky', top: 0, background: '#fafafa', padding: '8px', fontWeight: 'bold', borderBottom: '1px solid #ccc' }}>
    Seleccione una persona para editar la asistencia
  </div>
)}


         
 
                  <DataTable
                    columns={columns}
                    data={asistenciaMesAno}
                    progressPending={loading}
                    pagination
                    highlightOnHover
                    persistTableHead
                    fixedHeader
                    paginationPerPage={50}
                    paginationRowsPerPageOptions={[10, 25, 50, 100]} 
                    onRowClicked={(row) => setPersonaSeleccionada(row.NombreCompleto)}
                    conditionalRowStyles={[
                      {
                        when: row => row.NombreCompleto === personaSeleccionada,
                        style: {
                          backgroundColor: '#e6f7ff', // Azul clarito o el color que prefieras
                          fontWeight: 'bold',
                        },
                      },
                    ]}
                   
                  /> 


                </Form>
                </div>
                <div className="button-container mr-auto ml-auto">
                {
                <>
                

                  <Button
                  className="btn-fill pull-right ml-2"
                  type="info"
                  variant="reset"
                  onClick={() => excelExport(columns, asistenciaMesAno,columnasAsistenciaMes,'RegistroAsistencia')}
                  > <i className="fas fa-file-excel"></i> Exportar a Excel</Button>

                  <Button
                  className="btn-fill pull-right ml-2"
                  type="info"
                  variant="info"
                  onClick={handleSaveChanges}
                  > <i className="fas fa-save"></i> Guardar Cambios</Button>
                
                </>
               
                  }
                  </div>
                  <div className="clearfix"></div>
                  <br></br>
                  <MensajeAlerta mensajeTexto={respuestaActualizarAsistencia.mensajeTexto} estado={respuestaActualizarAsistencia.estado} />
                </Card.Body>
              </Card>
            </Col>
        </Row>
        </Container>
      </>
    );
}
export default RegistroAsistencia;